<template>
    <div>

        <div id="saveDomToPdf" class="pdf-wrap fixed" v-if="onlineData.hasOwnProperty('id')">
            <div class="pdf-logo-wrap">
                <div class="pdf-logo-box">
                    <img class="pdf-logo-img" src="@/assets/image/modal/logo_normal.png" alt=""/>
                    <span class="pdf-logo-text">KoreanSSam</span>
                </div>

                <div class="pdf-logo-information">
                    <div class="pdf-nickname">{{ onlineData.partner.mb_nick }}</div>
                    <div class="pdf-date">{{ returnDateUnix(recordData.created / 1000) }}</div>
                    <div class="pdf-language">{{returnLang(recordData, recordData.requestId)}} ↔ {{returnLang(recordData, recordData.receiverId)}}</div>
                </div>
            </div>

            <div class="pdf-timeLine-list-wrap">
                <div class="pdf-timeLine-box-wrap" v-for="(feedback, index) in feedbacks">
                    <div class="pdf-timeLine-box">
                        <div class="pdf-timeLine">{{ returnSecondToMinute(feedback.time) }}</div>
                        <div class="pdf-timeLine-text">{{ feedback.msg }}</div>
                    </div>
                </div>
            </div>
        </div>

        <modal name="correct-receive-modal" class="replay-modal"
               :width="'80%'"
               :height="'auto'"
               :pivotY="0.5"
               :pivotX="0.5"
               @before-close="handlerBeforeClose"
               @before-open="handlerBeforeOpen"
               @opened="handlerOpened">
            <div class="player-modal-wrap" v-if="onlineData.hasOwnProperty('id')">
                <div class="player-modal-title">
                    받은 첨삭
                    <button @click="savePdf()" v-if="feedbackData.writer != UserInfo.mb_uuid"></button>
                </div>

                <div class="player-wrap receive pt15 pb5">
                    <div class="player-nickname">{{ onlineData.partner.mb_nick }}</div>

                    <div class="player-timeLine-wrap">
                        <div class="player-timeLine-box" v-for="(feedback, index) in feedbacks">
                            <div class="player-timeLine">
                                <button class="player-timeWhen">{{ returnSecondToMinute(feedback.time) }}</button>
                                <ion-item class="player-timeText_box">
                                    <div class="player-timeText">{{ feedback.msg }}</div>
                                </ion-item>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="player-button-wrap">
                    <button @click="modalClose()">확인</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import audioPlayMixins from "@/components/online/audioPlayMixins";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import {mapState} from "vuex";
import alertMixins from "@/mixins/alertMixins";
import dateMixins from "@/mixins/dateMixins";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default {
    name: "CorrectReceiveModal",
    mixins: [audioPlayMixins, alertMixins, dateMixins],
    components: {
    },
    inject: [],
    provide() {
        return{

        }
    },
    props: {
    },
    data() {
        return{
            recordData: {},
            onlineData: {},
            relayUrl: '',
            showPlayer: false,
            feedbackData: {},

            feedbacks: [],
            showWrong: false,

        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo
        })
    },
    methods:{
        handlerBeforeOpen(event) {
            if(util.isEmpty(event.params) ||
                util.isEmpty(event.params.onlineData) ||
                util.isEmpty(event.params.feedbackData) ||
                util.isEmpty(event.params.recordData)) {
                event.stop();
                return false;
            }
            this.onlineData = event.params.onlineData;
            this.feedbackData = event.params.feedbackData;
            this.recordData = event.params.recordData;
            this.feedbacks = this.feedbackData.data.slice();
        },
        handlerOpened() {
            EventBus.$emit('pushBackFunc', this.modalClose);
        },
        handlerBeforeClose() {
            this.onlineData = {};
            this.relayUrl = '';
            this.audioData = {
                play: false,
                allTime: 0,
                currentTime: 0
            };
            this.feedbackData = {};
            this.feedbacks = [];
            this.recordData = {};
            EventBus.$emit('popBackFunc');
        },
        modalClose(){
            this.$modal.hide('correct-receive-modal');
        },
        returnLang(record, memberId) {
            return record.users[memberId].lang;
        },
        savePdf() {
            EventBus.$emit('apiLoading', true);
            let element = document.getElementById('saveDomToPdf');
            let fileName = `KoreanSSam-${this.onlineData.partner.mb_nick}-${this.returnDateUnix(this.recordData.created/1000)}.pdf`
            html2canvas(element).then(function(canvas) {
                // 캔버스를 이미지로 변환
                let imgData = canvas.toDataURL('image/png');

                let imgWidth = 210; // 이미지 가로 길이(mm) A4 기준
                let pageHeight = imgWidth * 1.414;  // 출력 페이지 세로 길이 계산 A4 기준
                let imgHeight = canvas.height * imgWidth / canvas.width;
                let heightLeft = imgHeight;

                let doc = new jsPDF('p', 'mm');
                let position = 0;

                // 첫 페이지 출력
                doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                // 한 페이지 이상일 경우 루프 돌면서 출력
                while (heightLeft >= 20) {
                    position = heightLeft - imgHeight;
                    doc.addPage();
                    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
                doc.save(fileName)
            });
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
